import * as Sentry from "@sentry/browser";
import Player from '@vimeo/player';
import { showOverlay } from './utils';

let vimeoPlayer;
let videoPlayer;
let currentInlineVideoPlayer;

function init() {
  document.querySelectorAll('.js-show-vimeo-overlay').forEach(el =>
    el.addEventListener('click', openVimeoOverlay));

  const closeVimeoOverlayEl = document.getElementById('close-vimeo-overlay');
  if(closeVimeoOverlayEl) {
    closeVimeoOverlayEl.addEventListener('click', closeVimeoOverlay);
  }

  document.querySelectorAll('.js-show-video-overlay').forEach(el =>
    el.addEventListener('click', openVideoOverlay));

  const closeVideoOverlayEl = document.getElementById('close-video-overlay');
  if(closeVideoOverlayEl) {
    closeVideoOverlayEl.addEventListener('click', closeVideoOverlay);
  }
}

const openVideoOverlay = event => {
  event.preventDefault();
  currentInlineVideoPlayer = event.currentTarget.querySelector('video');
  currentInlineVideoPlayer.pause();

  videoPlayer = document.getElementById('video-embed');
  videoPlayer.querySelector('source').src = currentInlineVideoPlayer.currentSrc;
  videoPlayer.load();
  showOverlay('video-overlay');
  videoPlayer.play();
}

export const openVimeoOverlay = (event, { url = null } = {}) => {
  if(event) {
    event.preventDefault();
    const btnEl = event.currentTarget;
    url = url ? url : btnEl.dataset.videoUrl;
  }

  let options = { width: 640 };

  if(url) {
    options = { url, ...options };
  } else {
    return;
  }
  vimeoPlayer = new Player('vimeo-embed', options);
  showOverlay('vimeo-overlay');
  vimeoPlayer.play();
}

const closeVideoOverlay = event => {
  event.preventDefault();
  try {
    currentInlineVideoPlayer.mute
    currentInlineVideoPlayer.play();
  } catch(e) {
    Sentry.captureException(e);
  }
  videoPlayer.pause();
}

const closeVimeoOverlay = event => {
  event.preventDefault();
  vimeoPlayer.destroy();
}

export default {init, openVimeoOverlay};